import { memo } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { RECAPTCHA_ENABLED, RECAPTCHA_SITE_KEY } from 'src/config/config'

interface Props {
  children: React.ReactNode
}

export const ReCaptcha: React.FC<Props> = memo(({ children }) => {
  if (RECAPTCHA_ENABLED) {
    return (
      <GoogleReCaptchaProvider
        reCaptchaKey={RECAPTCHA_SITE_KEY || ''}
        scriptProps={{ async: false, defer: false, appendTo: 'head', nonce: undefined }}
      >
        {children}
      </GoogleReCaptchaProvider>
    )
  } else {
    return <>{children}</>
  }
})
